import React from 'react';
import styled from 'styled-components';
import noise from '../images/NoiseLayer.svg';
import { mediaQueries } from '../shared/config';
import SpotifyEmbed from './SpotifyEmbed';

const Container = styled.a`
    width: 32vw;
    height: auto;
    overflow: auto;
    position: relative;
    background-image: url(${noise});
    background-color: #252525;
    font-family: 'Arsenal', sans-serif;
    font-size: 24px;
    font-weight: 500;
    ${mediaQueries.mobile} {
        width: 270px;
        height: 275px;
        overflow: auto;
        margin: auto;
        padding: 2px;
    }
    
`
const SpotifyEmbedContainer = styled.div`
    width: 32vw;
    ${mediaQueries.mobile} {
        width: 250px;
        height: auto;
        margin: auto;
    }
`
const Empty = styled.div ` 
    width: 30vw;
    height: 476px;
    position: relative;
    border: dotted black;
    
    font-family: 'Arsenal', sans-serif;
    font-size: 24px;
    font-weight: 500;
    ${mediaQueries.mobile} {
        width: 0px;
        height: 0px;
        margin: auto;
    }
`

const Image = styled.img`
    display: block;
    margin: auto;
    max-width: 100%;
    max-height:80%;
    box-sizing: border-box;
    padding: 10px;
    ${mediaQueries.mobile} {
        max-height: 200px;
    }
`;

const Caption = styled.div`
    width: 90%;
    height: 20%;
    padding-bottom: 4%;

    margin: 0 auto;
    color: #FFFFFF;
    font-size: 20px;
    font-family: 'Optima';
    ${mediaQueries.mobile}{ 
        font-size: 12px;
    }
`
const Author = styled.div`
    font-size: 18px;
    margin-top: 2%;
    margin-bottom: 0%;
    ${mediaQueries.mobile}{ 
        font-size: 10px;
    }
`

export default function Card(props) {
    if (props.type == "spotify") {
        return (
            <SpotifyEmbedContainer>
                {props.articleLink && <SpotifyEmbed link={props.articleLink}/>}
            </SpotifyEmbedContainer>
        )
    }
    if (props.type == "empty") {
        return <Empty></Empty>
    }
    return (
        <Container href={props.articleLink}> 
            <Image src={props.image}/>
            <Caption>
                <a href={props.articleLink} style = {{color: 'white'}}>{props.articleTitle}</a>
                <Author> By {props.author}</Author>
            </Caption>
        </Container>
    )
}